import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "testimonials",
  class: "pt-4 md:pt-6 pb-12 md:pb-16 bg-primary/10"
}
const _hoisted_2 = { class: "container mx-auto px-4 sm:px-6" }
const _hoisted_3 = { class: "relative max-w-5xl mx-auto" }
const _hoisted_4 = { class: "flex flex-col md:flex-row gap-6 md:gap-8 items-center md:items-start" }
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = {
  key: 0,
  class: "w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 rounded-full overflow-hidden ring-4 ring-primary/20 shadow-lg"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 1,
  class: "w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 rounded-full bg-primary text-white flex items-center justify-center text-2xl sm:text-3xl md:text-4xl font-bold shadow-lg ring-4 ring-primary/20"
}
const _hoisted_9 = { class: "flex-1 text-center md:text-left" }
const _hoisted_10 = { class: "mb-4 md:mb-6" }
const _hoisted_11 = { class: "text-base sm:text-lg md:text-xl text-gray-700 italic leading-relaxed" }
const _hoisted_12 = { class: "pt-3 md:pt-4 border-t border-gray-200" }
const _hoisted_13 = { class: "font-bold text-lg md:text-xl text-safari-black mb-1" }
const _hoisted_14 = { class: "text-primary font-medium text-sm md:text-base" }
const _hoisted_15 = {
  key: 0,
  class: "text-xs sm:text-sm text-gray-500 mt-1"
}
const _hoisted_16 = { class: "flex justify-center mt-8 gap-3" }
const _hoisted_17 = ["onClick", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardContent = _resolveComponent("CardContent")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-3xl sm:text-4xl md:text-4xl font-bold text-center mb-2 md:mb-3 text-primary" }, "Quotes", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              key: _ctx.currentTestimonial,
              class: "testimonial-card"
            }, [
              _createVNode(_component_Card, { class: "bg-white shadow-lg" }, {
                default: _withCtx(() => [
                  _createVNode(_component_CardContent, { class: "p-6 md:p-8 lg:p-10" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          (_ctx.testimonials[_ctx.currentTestimonial].image && _ctx.isValidImage(_ctx.testimonials[_ctx.currentTestimonial].image))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("img", {
                                  src: _ctx.testimonials[_ctx.currentTestimonial].image,
                                  alt: _ctx.testimonials[_ctx.currentTestimonial].name,
                                  class: "w-full h-full object-cover",
                                  onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                                }, null, 40, _hoisted_7)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.getInitials(_ctx.testimonials[_ctx.currentTestimonial].name)), 1))
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _cache[3] || (_cache[3] = _createElementVNode("svg", {
                              class: "w-8 h-8 sm:w-10 sm:h-10 text-primary/30 mx-auto md:mx-0 mb-3 md:mb-4",
                              fill: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", { d: "M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.996 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.984zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" })
                            ], -1)),
                            _createElementVNode("p", _hoisted_11, " \"" + _toDisplayString(_ctx.testimonials[_ctx.currentTestimonial].quote) + "\" ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.testimonials[_ctx.currentTestimonial].name), 1),
                            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.testimonials[_ctx.currentTestimonial].role), 1),
                            (_ctx.testimonials[_ctx.currentTestimonial].location)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.testimonials[_ctx.currentTestimonial].location), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testimonials, (testimonial, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: index,
              onClick: ($event: any) => (_ctx.goToTestimonial(index)),
              class: _normalizeClass([
              'w-3 h-3 rounded-full transition-all duration-300',
              _ctx.currentTestimonial === index
                ? 'bg-primary w-8'
                : 'bg-gray-300 hover:bg-primary/50'
            ]),
              "aria-label": `View testimonial from ${testimonial.name}`
            }, null, 10, _hoisted_17))
          }), 128))
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previousTestimonial && _ctx.previousTestimonial(...args))),
          class: "absolute left-0 md:-left-12 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white shadow-lg flex items-center justify-center hover:bg-primary hover:text-white transition-colors group",
          "aria-label": "Previous testimonial"
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            class: "w-5 h-5 sm:w-6 sm:h-6 text-gray-600 group-hover:text-white transition-colors",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M15 19l-7-7 7-7"
            })
          ], -1)
        ]))]),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextTestimonial && _ctx.nextTestimonial(...args))),
          class: "absolute right-0 md:-right-12 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white shadow-lg flex items-center justify-center hover:bg-primary hover:text-white transition-colors group",
          "aria-label": "Next testimonial"
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("svg", {
            class: "w-5 h-5 sm:w-6 sm:h-6 text-gray-600 group-hover:text-white transition-colors",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 5l7 7-7 7"
            })
          ], -1)
        ]))])
      ])
    ])
  ]))
}